import { render, staticRenderFns } from "./ContractCard.vue?vue&type=template&id=45ec69cc&scoped=true"
import script from "./ContractCard.vue?vue&type=script&lang=ts"
export * from "./ContractCard.vue?vue&type=script&lang=ts"
import style0 from "./ContractCard.vue?vue&type=style&index=0&id=45ec69cc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ec69cc",
  null
  
)

export default component.exports